import { ConfigProvider } from "antd";
import fetch from "auth/FetchInterceptor";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import useBodyClass from "hooks/useBodyClass";
import AppLocale from "lang";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import ProtectedRoute from "./auth-views/ProtectedRoute/protected-route";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { useEffect } from "react";
import { requestLangData } from "redux/actions/Lookup";

import _ from "lodash";
export const Views = (props) => {
  const {
    token,
    locale,
    location,
    direction,
    currentTheme,
    lkLanguages,
    requestLangData,
  } = props;
  useEffect(() => {
    if (lkLanguages === null || _.isEmpty(lkLanguages)) {
      requestLangData();
    }
  }, [lkLanguages, requestLangData]);
  const defaultKey = Object.keys(AppLocale)[0];
  const currentAppLocale =
    AppLocale[locale] === undefined ? AppLocale[defaultKey] : AppLocale[locale];
  const themes = {
    dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
  };
  useBodyClass(`dir-${direction}`);
  useBodyClass(currentTheme === "dark" ? "theme-dark" : "theme-light");
  return (
    <ThemeSwitcherProvider
      themeMap={themes}
      defaultTheme={currentTheme}
      insertionPoint="styles-insertion-point"
    >
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
          <SWRConfig
            value={{
              fetcher: (key) => {
                const { url, params, headers } = key || {};
                const config = { params };
                if (headers && typeof headers === "object") {
                  config.headers = headers;
                }
                return fetch.get(url, config).then((r) => r);
              },
              revalidateIfStale: false,
              revalidateOnFocus: false,
              revalidateOnReconnect: false,
              refreshWhenHidden: false,
              refreshInterval: 0,
              shouldRetryOnError: false,
            }}
          >
            <Switch>
              <Route exact path="/">
                <Redirect to={APP_PREFIX_PATH} />
              </Route>
              <Route path={AUTH_PREFIX_PATH}>
                <AuthLayout direction={direction} />
              </Route>
              <ProtectedRoute
                path={APP_PREFIX_PATH}
                isAuthenticated={token}
                location={location}
              >
                <AppLayout direction={direction} location={location} />
              </ProtectedRoute>
            </Switch>
          </SWRConfig>
        </ConfigProvider>
      </IntlProvider>
    </ThemeSwitcherProvider>
  );
};

const mapStateToProps = ({ theme, auth, lookup }) => {
  const { locale, direction, currentTheme } = theme;
  const { token } = auth;
  const { lkLanguages } = lookup;
  return { locale, token, direction, lkLanguages, currentTheme };
};
const mapDispatchToProps = {
  requestLangData,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Views));
